module.exports = __webpack_public_path__ + "static/cashBox-7523bed72122af2e1cfdda40bab59a0e.png";